export default {
  filterBy: state => state.filterBy,
  sortBy: state => state.sortBy,
  orderBy: state => state.orderBy,
  previousPage: state => state.previousPage,
  nextPage: state => state.nextPage
};